export default __webpack_public_path__ + "static/media/imageIcon.74bd6579.svg";